export class FactionModal {
  constructor() {
    // Class properties
    this.modalActiveClass = 'modal-faction-active';

    // Cache DOM elements
    this.body = document.body;
    this.modal = document.querySelector("#modal-faction");

    // Bind methods to preserve context
    this.handleModalOpen = this.handleModalOpen.bind(this);

    this.init();
  }

  init() {
    this.addEventListeners();
  }

  addEventListeners() {
    // Use event delegation for modal opener clicks
    document.body.addEventListener('click', (e) => {
      if (e.target.closest('[href^="#modal-faction"]')) {
        e.preventDefault();
        this.handleModalOpen(e);
      }

      if (e.target.closest('#modal-faction .modal-close-btn')) {
        this.handleModalClose(e);
      }

      if (!e.target.closest('[href^="#modal-faction"]') && !e.target.closest('#modal-faction .modal-box')) {
        this.handleModalClose(e);
      }
    });
  }

  handleModalOpen() {
    this.body.classList.add(this.modalActiveClass);
    this.modal.classList.add('show');
  }

  handleModalClose() {
    this.body.classList.remove(this.modalActiveClass);
    this.modal.classList.remove("show");
  }

  dispose() {
    // Clean up references
    this.body = null;
    this.modal = null;
  }
}
